import { POST } from "../../../helpers/restFunction";
export const CreateTicket = async (userId: String, data: Object) => {
  const path = `/cad/${userId}/cad_support`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
